// extracted by css-extract-rspack-plugin
export default {"container":"DraggableRowOverlay_container__qdStm","dragIconWrapper":"DraggableRowOverlay_dragIconWrapper__FMewU","sizeM":"DraggableRowOverlay_sizeM__6OTG7"};